import React from 'react';
import { Box, Typography, Container, Button } from '@mui/material';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';

const benefits = [
    {
        icon: '/images/home/clock-2 1.png',
        title: '24/7 AI Assistant',
        description: 'Your AI digital clone works around the clock as a virtual agent, handling customer inquiries and lead follow-ups while you focus on closing deals and growing your business.'
    },
    {
        icon: '/images/home/two-pieces-of-chain-connected-together 1.png',
        title: 'Personal Brand Amplification',
        description: 'Your conversational AI reflects your unique personality, voice, and expertise. This AI agent builder creates a digital twin that maintains authentic connections with every customer interaction.'
    },
    {
        icon: '/images/home/Frame.png',
        title: 'Sales AI Agent Excellence',
        description: 'Scale your customer service with an AI agentic system that integrates seamlessly as a Salesforce agent, providing live chat support that feels like talking to you personally.'
    }
];

export default function WhyDigitalClone() {
    return (
        <Box
            id="why-digital-clone"
            sx={{
                py: { xs: 6, md: 10 },
                background: 'linear-gradient(to bottom, #f8fafc 0%, #f0f7ff 50%, #ECF5FF 100%)'
            }}
        >
            <Container maxWidth="lg">
                <Grid container spacing={8} alignItems="center">
                    <Grid size={{ xs: 12, md: 6 }}>
                        <Box sx={{ textAlign: { xs: 'center', md: 'left' } }}>
                            <Typography
                                variant="h2"
                                fontWeight="bold"
                                sx={{
                                    fontSize: { xs: '40px', md: '56px' },
                                    color: '#1e293b',
                                    mb: 4,
                                    lineHeight: 1.2
                                }}
                            >
                                Why Digital Clone?
                            </Typography>
                            <Typography
                                variant="body1"
                                sx={{
                                    fontSize: { xs: '20px', md: '23px' },
                                    color: '#64748b',
                                    mb: 5,
                                    lineHeight: 1.6
                                }}
                            >
                                With AI Clone, you're not just working smarter – you're amplifying your ability to communicate with Your customer 24/7, address customer's requests and questions with the animated avatar using your look, your voice and your knowledge base amplifying your personal brand.
                            </Typography>
                            <Button
                                variant="contained"
                                size="large"
                                sx={{
                                    bgcolor: "#5C78FF",
                                    borderRadius: "30px",
                                    px: 4,
                                    py: 1.5,
                                    fontSize: '16px',
                                    fontWeight: "600",
                                    textTransform: "none",
                                    boxShadow: '0 4px 15px rgba(92, 120, 255, 0.3)',
                                    '&:hover': {
                                        bgcolor: "#4660c8",
                                        boxShadow: '0 6px 20px rgba(92, 120, 255, 0.4)'
                                    }
                                }}
                                onClick={() => alert("Contact us at contact@eternity.ac")}
                            >
                                Try for free
                            </Button>
                        </Box>
                    </Grid>

                    <Grid size={{ xs: 12, md: 6 }}>
                        <Box sx={{
                            position: { xs: 'static', md: 'relative' },
                            height: { xs: 'auto', md: '500px' },
                            display: { xs: 'flex', md: 'block' },
                            flexDirection: { xs: 'column', md: 'row' },
                            alignItems: { xs: 'center', md: 'stretch' },
                            gap: { xs: '10px', md: 0 }
                        }}>
                            {benefits.map((benefit, index) => (
                                <Box
                                    key={index}
                                    sx={{
                                        position: { xs: 'static', md: 'absolute' },
                                        top: { xs: 'auto', md: `${index * 190 - 30}px` },
                                        right: { xs: 'auto', md: `${index * 60}px` },
                                        width: { xs: '100%', md: '500px' },
                                        maxWidth: { xs: '350px', md: '500px' },
                                        bgcolor: 'white',
                                        borderRadius: '20px',
                                        p: 4,
                                        boxShadow: '0 10px 25px -5px rgba(0, 0, 0, 0.1), 0 8px 10px -6px rgba(0, 0, 0, 0.1)',
                                        border: '1px solid #f1f5f9',
                                        zIndex: { xs: 1, md: index + 1 },
                                        textAlign: { xs: 'left', md: 'left' }
                                    }}
                                >
                                    <Stack
                                        direction="row"
                                        spacing={3}
                                        alignItems="center"
                                    >
                                        <Box
                                            sx={{
                                                width: 56,
                                                height: 56,
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                flexShrink: 0
                                            }}
                                        >
                                            <Box
                                                component="img"
                                                src={benefit.icon}
                                                alt={benefit.title}
                                                sx={{
                                                    width: 48,
                                                    height: 48
                                                }}
                                            />
                                        </Box>
                                        <Box sx={{ flex: 1 }}>
                                            <Typography
                                                variant="h6"
                                                fontWeight="bold"
                                                sx={{
                                                    color: '#1e293b',
                                                    mb: '5px',
                                                    fontSize: '21px'
                                                }}
                                            >
                                                {benefit.title}
                                            </Typography>
                                            <Typography
                                                variant="body2"
                                                sx={{
                                                    color: '#64748b',
                                                    fontSize: '16px',
                                                    lineHeight: 1.5
                                                }}
                                            >
                                                {benefit.description}
                                            </Typography>
                                        </Box>
                                    </Stack>
                                </Box>
                            ))}
                        </Box>
                    </Grid>
                </Grid>
            </Container>
        </Box>
    );
}